"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ThemeHelper = require("../Utilities/ThemeHelper");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var useStyles = (0, _ThemeHelper.makeStyles)(function (theme) {
  return {
    button: _objectSpread(_objectSpread({
      borderRadius: 0
    }, theme.typography.button), {}, {
      padding: theme.spacing(1.6, 2.4),
      boxShadow: "none",
      "&:active": {
        boxShadow: "none"
      },
      "&:hover": {
        backgroundImage: "none"
      },
      textShadow: "none"
    }),
    fab: {},
    inner: {
      margin: "0 auto"
    },
    iconButton: {
      fontSize: theme.typography.h5.fontSize,
      boxShadow: "none",
      "&:active": {
        boxShadow: "none"
      },
      "&:hover": {
        backgroundImage: "none"
      },
      textShadow: "none"
    },
    mainLoadingButton: {
      position: "absolute"
    },
    sizeSmall: {
      padding: theme.spacing(0.8, 1.2)
    },
    iconButtonSizeSmall: {
      padding: 10,
      fontSize: theme.typography.fontSize
    },
    sizeLarge: {
      padding: theme.spacing(2.4, 3.6)
    },
    iconButtonSizeLarge: {
      padding: theme.spacing(2.25),
      fontSize: 24
    },
    startIcon: {
      display: "inherit",
      marginRight: theme.spacing(1),
      marginLeft: theme.spacing(-0.5)
    },
    endIcon: {
      display: "inherit",
      marginRight: theme.spacing(-0.5),
      marginLeft: theme.spacing(1)
    },
    tooltipFix: {
      pointerEvents: "auto !important",
      cursor: "not-allowed !important"
    }
  };
});
var _default = useStyles;
exports.default = _default;